import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, mergeProps as _mergeProps, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/images/iknowa-thumbnail.png'
import _imports_1 from '../../assets/images/user-placeholder.jpg'
import _imports_2 from '@/assets/icons/dots.svg'


const _withScopeId = n => (_pushScopeId("data-v-47015e22"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "notification_overlay" }, null, -1))
const _hoisted_2 = {
  key: 0,
  class: "notification_body_overlay"
}
const _hoisted_3 = { class: "notification_wrapper__header" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Notifications", -1))
const _hoisted_5 = { class: "prefix" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 0,
  class: "notification_wrapper__new_item"
}
const _hoisted_8 = { class: "notification_wrapper__list_item_content" }
const _hoisted_9 = { class: "notification_wrapper__img" }
const _hoisted_10 = ["src"]
const _hoisted_11 = {
  key: 1,
  src: _imports_0,
  alt: ""
}
const _hoisted_12 = {
  key: 2,
  src: _imports_1
}
const _hoisted_13 = {
  key: 0,
  class: "notification_wrapper__user_content"
}
const _hoisted_14 = { class: "notification_wrapper__text" }
const _hoisted_15 = {
  key: 1,
  class: "notification_wrapper__user_content"
}
const _hoisted_16 = { class: "notification_wrapper__text" }
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = {
  key: 2,
  class: "notification_wrapper__user_content"
}
const _hoisted_19 = { class: "notification_wrapper__text" }
const _hoisted_20 = {
  key: 3,
  class: "notification_wrapper__user_content"
}
const _hoisted_21 = { class: "notification_wrapper__text" }
const _hoisted_22 = ["innerHTML"]
const _hoisted_23 = {
  key: 4,
  class: "notification_wrapper__user_content"
}
const _hoisted_24 = { class: "notification_wrapper__user_content_info" }
const _hoisted_25 = { class: "notification_wrapper__text" }
const _hoisted_26 = ["innerHTML"]
const _hoisted_27 = { class: "notification_wrapper__buttons" }
const _hoisted_28 = {
  key: 5,
  class: "notification_wrapper__user_content"
}
const _hoisted_29 = { class: "notification_wrapper__text" }
const _hoisted_30 = ["innerHTML"]
const _hoisted_31 = {
  key: 6,
  class: "notification_wrapper__user_content"
}
const _hoisted_32 = { class: "notification_wrapper__text" }
const _hoisted_33 = ["innerHTML"]
const _hoisted_34 = {
  key: 7,
  class: "notification_wrapper__user_content"
}
const _hoisted_35 = { class: "notification_wrapper__text" }
const _hoisted_36 = ["innerHTML"]
const _hoisted_37 = {
  key: 8,
  class: "notification_wrapper__user_content"
}
const _hoisted_38 = { class: "notification_wrapper__text" }
const _hoisted_39 = ["innerHTML"]
const _hoisted_40 = {
  key: 9,
  class: "notification_wrapper__user_content"
}
const _hoisted_41 = { class: "notification_wrapper__text" }
const _hoisted_42 = ["innerHTML"]
const _hoisted_43 = {
  key: 10,
  class: "notification_wrapper__user_content"
}
const _hoisted_44 = { class: "notification_wrapper__text" }
const _hoisted_45 = ["innerHTML"]
const _hoisted_46 = {
  key: 11,
  class: "notification_wrapper__user_content"
}
const _hoisted_47 = { class: "notification_wrapper__text" }
const _hoisted_48 = ["innerHTML"]
const _hoisted_49 = {
  key: 12,
  class: "notification_wrapper__user_content"
}
const _hoisted_50 = { class: "notification_wrapper__text" }
const _hoisted_51 = ["innerHTML"]
const _hoisted_52 = {
  key: 13,
  class: "notification_wrapper__user_content"
}
const _hoisted_53 = { class: "notification_wrapper__text" }
const _hoisted_54 = ["innerHTML"]
const _hoisted_55 = {
  key: 14,
  class: "notification_wrapper__user_content"
}
const _hoisted_56 = { class: "notification_wrapper__text" }
const _hoisted_57 = ["innerHTML"]
const _hoisted_58 = {
  key: 15,
  class: "notification_wrapper__user_content"
}
const _hoisted_59 = { class: "notification_wrapper__text" }
const _hoisted_60 = ["innerHTML"]
const _hoisted_61 = {
  key: 16,
  class: "notification_wrapper__user_content"
}
const _hoisted_62 = { class: "notification_wrapper__text" }
const _hoisted_63 = {
  key: 17,
  class: "notification_wrapper__user_content"
}
const _hoisted_64 = { class: "notification_wrapper__user_content_info" }
const _hoisted_65 = { class: "notification_wrapper__text" }
const _hoisted_66 = { class: "notification_wrapper__buttons" }
const _hoisted_67 = {
  key: 18,
  class: "notification_wrapper__user_content"
}
const _hoisted_68 = { class: "notification_wrapper__user_content_info" }
const _hoisted_69 = { class: "notification_wrapper__text" }
const _hoisted_70 = { class: "notification_wrapper__buttons" }
const _hoisted_71 = {
  key: 19,
  class: "notification_wrapper__user_content"
}
const _hoisted_72 = { class: "notification_wrapper__user_content_info" }
const _hoisted_73 = { class: "notification_wrapper__text" }
const _hoisted_74 = { class: "notification_wrapper__buttons" }
const _hoisted_75 = {
  key: 20,
  class: "notification_wrapper__user_content"
}
const _hoisted_76 = { class: "notification_wrapper__text" }
const _hoisted_77 = ["innerHTML"]
const _hoisted_78 = {
  key: 21,
  class: "notification_wrapper__user_content"
}
const _hoisted_79 = { class: "notification_wrapper__text" }
const _hoisted_80 = ["innerHTML"]
const _hoisted_81 = {
  key: 22,
  class: "notification_wrapper__user_content"
}
const _hoisted_82 = { class: "notification_wrapper__text" }
const _hoisted_83 = ["innerHTML"]
const _hoisted_84 = {
  key: 23,
  class: "notification_wrapper__user_content"
}
const _hoisted_85 = { class: "notification_wrapper__user_content_info" }
const _hoisted_86 = { class: "notification_wrapper__text" }
const _hoisted_87 = ["innerHTML"]
const _hoisted_88 = {
  key: 24,
  class: "notification_wrapper__user_content"
}
const _hoisted_89 = { class: "notification_wrapper__user_content_info" }
const _hoisted_90 = { class: "notification_wrapper__text" }
const _hoisted_91 = ["innerHTML"]
const _hoisted_92 = {
  key: 25,
  class: "notification_wrapper__user_content"
}
const _hoisted_93 = { class: "notification_wrapper__user_content_info" }
const _hoisted_94 = { class: "notification_wrapper__text" }
const _hoisted_95 = {
  key: 26,
  class: "notification_wrapper__user_content"
}
const _hoisted_96 = { class: "notification_wrapper__user_content_info" }
const _hoisted_97 = { class: "notification_wrapper__text" }
const _hoisted_98 = { class: "notification_wrapper__buttons" }
const _hoisted_99 = {
  key: 27,
  class: "notification_wrapper__user_content"
}
const _hoisted_100 = { class: "notification_wrapper__user_content_info" }
const _hoisted_101 = { class: "notification_wrapper__text" }
const _hoisted_102 = ["innerHTML"]
const _hoisted_103 = { class: "notification_wrapper__buttons" }
const _hoisted_104 = {
  key: 28,
  class: "notification_wrapper__user_content"
}
const _hoisted_105 = { class: "notification_wrapper__user_content_info" }
const _hoisted_106 = { class: "notification_wrapper__text" }
const _hoisted_107 = { key: 0 }
const _hoisted_108 = { key: 1 }
const _hoisted_109 = {
  key: 0,
  class: "notification_wrapper__buttons"
}
const _hoisted_110 = {
  key: 29,
  class: "notification_wrapper__user_content"
}
const _hoisted_111 = { class: "notification_wrapper__user_content_info" }
const _hoisted_112 = { class: "notification_wrapper__text" }
const _hoisted_113 = { class: "notification_wrapper__buttons" }
const _hoisted_114 = {
  key: 30,
  class: "notification_wrapper__user_content"
}
const _hoisted_115 = { class: "notification_wrapper__user_content_info" }
const _hoisted_116 = { class: "notification_wrapper__text" }
const _hoisted_117 = { class: "notification_wrapper__buttons" }
const _hoisted_118 = {
  key: 31,
  class: "notification_wrapper__user_content"
}
const _hoisted_119 = { class: "notification_wrapper__user_content_info" }
const _hoisted_120 = { class: "notification_wrapper__text" }
const _hoisted_121 = {
  key: 32,
  class: "notification_wrapper__user_content"
}
const _hoisted_122 = { class: "notification_wrapper__user_content_info" }
const _hoisted_123 = { class: "notification_wrapper__text" }
const _hoisted_124 = { class: "notification_wrapper__buttons" }
const _hoisted_125 = {
  key: 33,
  class: "notification_wrapper__user_content"
}
const _hoisted_126 = { class: "notification_wrapper__user_content_info" }
const _hoisted_127 = { class: "notification_wrapper__text" }
const _hoisted_128 = { class: "notification_wrapper__buttons" }
const _hoisted_129 = {
  key: 34,
  class: "notification_wrapper__user_content"
}
const _hoisted_130 = { class: "notification_wrapper__user_content_info" }
const _hoisted_131 = { class: "notification_wrapper__text" }
const _hoisted_132 = { class: "notification_wrapper__buttons" }
const _hoisted_133 = {
  key: 35,
  class: "notification_wrapper__user_content"
}
const _hoisted_134 = { class: "notification_wrapper__user_content_info" }
const _hoisted_135 = { class: "notification_wrapper__text" }
const _hoisted_136 = {
  key: 36,
  class: "notification_wrapper__user_content"
}
const _hoisted_137 = { class: "notification_wrapper__user_content_info" }
const _hoisted_138 = { class: "notification_wrapper__text" }
const _hoisted_139 = {
  key: 37,
  class: "notification_wrapper__user_content"
}
const _hoisted_140 = { class: "notification_wrapper__user_content_info" }
const _hoisted_141 = { class: "notification_wrapper__text" }
const _hoisted_142 = {
  key: 38,
  class: "notification_wrapper__user_content"
}
const _hoisted_143 = { class: "notification_wrapper__user_content_info" }
const _hoisted_144 = { class: "notification_wrapper__text" }
const _hoisted_145 = {
  key: 39,
  class: "notification_wrapper__user_content"
}
const _hoisted_146 = { class: "notification_wrapper__user_content_info" }
const _hoisted_147 = { class: "notification_wrapper__text" }
const _hoisted_148 = {
  key: 40,
  class: "notification_wrapper__more_button"
}
const _hoisted_149 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loader = _resolveComponent("Loader")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_TrashIcon = _resolveComponent("TrashIcon")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_SelectMultipleWorkstationModal = _resolveComponent("SelectMultipleWorkstationModal")!
  const _component_VideoComponent = _resolveComponent("VideoComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["notification_wrapper", { 'is-in-default': $setup.isUserWorkstationIsDefault }])
    }, [
      _hoisted_1,
      _createElementVNode("div", {
        class: _normalizeClass(["notification_wrapper_body md:!tw-min-w-[300px] !tw-min-w-[545px] !tw-top-[.5rem] !tw-right-0 no-scrollbar md:!tw-max-h-[400px]", {
        '!tw-right-[0] s540:!tw-top-[-9px] s540:!tw-right-[29px] s540:!tw-max-w-[315px] sm:!tw-right-[38px] sm:!tw-max-w-[400px]':
          $setup.isUserWorkstationIsDefault,
        'sm:!tw-right-[-5px]': !$setup.isUserWorkstationIsDefault,
      }])
      }, [
        ($setup.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2))
          : _createCommentVNode("", true),
        _createVNode(_component_Loader, { show: $setup.loading }, null, 8, ["show"]),
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          ($setup.hasUnreadNotifications)
            ? (_openBlock(), _createElementBlock("p", {
                key: 0,
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.onClickMarkAllNotificationAsRead && $setup.onClickMarkAllNotificationAsRead(...args)))
              }, " Mark as read "))
            : _createCommentVNode("", true)
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.combinedNotifications, (group, date) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "notification_wrapper__list",
            key: date
          }, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("span", null, _toDisplayString(date), 1)
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group, (notification, i) => {
              return (_openBlock(), _createElementBlock("div", {
                onClick: ($event: any) => ($setup.onNotificationClick(notification)),
                key: i,
                class: "notification_wrapper__list_item"
              }, [
                (notification.state == $setup.NotificationStateEnum.UNREAD)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    (notification?.profileImage)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: notification?.profileImage,
                          alt: ""
                        }, null, 8, _hoisted_10))
                      : (
                  notification?.fromUser?.role?.id === 1 &&
                  notification?.fromUser?.role?.name === 'Administrator'
                )
                        ? (_openBlock(), _createElementBlock("img", _hoisted_11))
                        : (_openBlock(), _createElementBlock("img", _hoisted_12))
                  ]),
                  (
                notification.type === $setup.UserNotificationType.INSURANCEEXPIRATION
              )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("p", null, [
                            _createElementVNode("strong", null, _toDisplayString(notification.content), 1)
                          ]),
                          _createElementVNode("span", null, _toDisplayString(notification?.timeAgo), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (
                notification.type ===
                  $setup.UserNotificationType.DISPUTE_PROJECT_STATUS ||
                notification.type === $setup.UserNotificationType.PROJECT_REFUNDS
              )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, [
                          _createElementVNode("p", {
                            innerHTML: notification.content
                          }, null, 8, _hoisted_17),
                          _createElementVNode("span", null, _toDisplayString(notification?.timeAgo), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (
                notification.type ===
                $setup.UserNotificationType.CHANGE_ESTIMATE_REQUEST
              )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                        _createElementVNode("div", _hoisted_19, [
                          _createElementVNode("p", null, [
                            _createElementVNode("strong", null, _toDisplayString(notification.content), 1)
                          ]),
                          _createElementVNode("span", null, _toDisplayString(notification?.timeAgo), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (notification.type === $setup.UserNotificationType.INFORMATIVE)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                        _createElementVNode("div", _hoisted_21, [
                          _createElementVNode("p", {
                            innerHTML: notification.content
                          }, null, 8, _hoisted_22),
                          _createElementVNode("span", null, _toDisplayString(notification?.timeAgo), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (
                notification.type === $setup.UserNotificationType.WA_MEMBER_REQUEST
              )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                        _createElementVNode("div", _hoisted_24, [
                          _createElementVNode("div", _hoisted_25, [
                            _createElementVNode("p", {
                              innerHTML: notification.content
                            }, null, 8, _hoisted_26),
                            _createElementVNode("span", null, _toDisplayString(notification?.timeAgo), 1)
                          ]),
                          _createElementVNode("div", _hoisted_27, [
                            _createVNode(_component_v_btn, {
                              class: "notification_wrapper__accept",
                              variant: "tonal",
                              disable: $setup.isMemberRequestActionLoading,
                              loading: 
                      $setup.isMemberRequestActionLoading ===
                      $setup.UserNetworkRequestStatus.ACCEPTED
                    ,
                              onClick: ($event: any) => (
                      $setup.onClickMemberRequestAction(
                        $setup.UserNetworkRequestStatus.ACCEPTED,
                        notification
                      )
                    )
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Accept")
                              ]),
                              _: 2
                            }, 1032, ["disable", "loading", "onClick"]),
                            _createVNode(_component_v_btn, {
                              loading: 
                      $setup.isMemberRequestActionLoading ===
                      $setup.UserNetworkRequestStatus.REJECTED
                    ,
                              disable: $setup.isMemberRequestActionLoading,
                              class: "notification_wrapper__reject",
                              variant: "tonal",
                              onClick: ($event: any) => (
                      $setup.onClickMemberRequestAction(
                        $setup.UserNetworkRequestStatus.REJECTED,
                        notification
                      )
                    )
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Reject")
                              ]),
                              _: 2
                            }, 1032, ["loading", "disable", "onClick"])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (
                notification.type === $setup.UserNotificationType.INVITECALENDAREVENT
              )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                        _createElementVNode("div", _hoisted_29, [
                          _createElementVNode("p", {
                            innerHTML: notification.content
                          }, null, 8, _hoisted_30),
                          _createElementVNode("span", null, _toDisplayString(notification?.timeAgo), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (notification.type === $setup.UserNotificationType.PROJECTDELETED)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                        _createElementVNode("div", _hoisted_32, [
                          _createElementVNode("p", {
                            innerHTML: notification.content
                          }, null, 8, _hoisted_33),
                          _createElementVNode("span", null, _toDisplayString(notification?.timeAgo), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (
                notification.type ===
                $setup.UserNotificationType.TRADEUSERPROJECTACCEPTEDDIRECT
              )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                        _createElementVNode("div", _hoisted_35, [
                          _createElementVNode("p", {
                            innerHTML: notification.content
                          }, null, 8, _hoisted_36),
                          _createElementVNode("span", null, _toDisplayString(notification?.timeAgo), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (notification.type === $setup.UserNotificationType.ASSIGNEDCOURSE)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                        _createElementVNode("div", _hoisted_38, [
                          _createElementVNode("p", {
                            innerHTML: notification.content
                          }, null, 8, _hoisted_39),
                          _createElementVNode("span", null, _toDisplayString(notification?.timeAgo), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (
                notification.type ===
                $setup.UserNotificationType.ESTIMATE_ACCEPTED_BY_PO
              )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                        _createElementVNode("div", _hoisted_41, [
                          _createElementVNode("p", {
                            innerHTML: notification.content
                          }, null, 8, _hoisted_42),
                          _createElementVNode("span", null, _toDisplayString(notification?.timeAgo), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (
                notification.type ===
                $setup.UserNotificationType.REJECT_ESTIMATE_BY_PO_USER
              )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                        _createElementVNode("div", _hoisted_44, [
                          _createElementVNode("p", {
                            innerHTML: notification.content
                          }, null, 8, _hoisted_45),
                          _createElementVNode("span", null, _toDisplayString(notification?.timeAgo), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (
                notification.type === $setup.UserNotificationType.VIDEO_CONSULTATION
              )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                        _createElementVNode("div", _hoisted_47, [
                          _createElementVNode("p", {
                            innerHTML: notification.content
                          }, null, 8, _hoisted_48),
                          _createElementVNode("span", null, _toDisplayString(notification?.timeAgo), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (notification.type === $setup.UserNotificationType.ESTIMATEARRIVALS)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                        _createElementVNode("div", _hoisted_50, [
                          _createElementVNode("p", {
                            innerHTML: notification.content
                          }, null, 8, _hoisted_51),
                          _createElementVNode("span", null, _toDisplayString(notification?.timeAgo), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (
                notification.type === $setup.UserNotificationType.KYC_STATUS_UPDATION
              )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                        _createElementVNode("div", _hoisted_53, [
                          _createElementVNode("p", {
                            innerHTML: notification.content
                          }, null, 8, _hoisted_54),
                          _createElementVNode("span", null, _toDisplayString(notification?.timeAgo), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (
                notification.type === $setup.UserNotificationType.INSURANCE_ARCHIVED
              )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                        _createElementVNode("div", _hoisted_56, [
                          _createElementVNode("p", {
                            innerHTML: notification.content
                          }, null, 8, _hoisted_57),
                          _createElementVNode("span", null, _toDisplayString(notification?.timeAgo), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (
                notification.type === $setup.UserNotificationType.CLIENTORCONTRACTOR
              )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                        _createElementVNode("div", _hoisted_59, [
                          _createElementVNode("p", {
                            innerHTML: notification.content
                          }, null, 8, _hoisted_60),
                          _createElementVNode("span", null, _toDisplayString(notification?.timeAgo), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (notification.type === $setup.UserNotificationType.PHASE_REQUEST)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                        _createElementVNode("div", _hoisted_62, [
                          _createElementVNode("p", null, _toDisplayString(notification.content), 1),
                          _createElementVNode("span", null, _toDisplayString(notification?.timeAgo), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (notification.type === $setup.UserNotificationType.USER_NETWORK)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                        _createElementVNode("div", _hoisted_64, [
                          _createElementVNode("div", _hoisted_65, [
                            _createElementVNode("p", null, [
                              _createElementVNode("strong", null, _toDisplayString(notification.content), 1),
                              _createTextVNode(" has sent you trade network connection request ")
                            ]),
                            _createElementVNode("span", null, _toDisplayString(notification?.timeAgo), 1)
                          ]),
                          _createElementVNode("div", _hoisted_66, [
                            _createVNode(_component_v_btn, {
                              class: "notification_wrapper__accept",
                              variant: "tonal",
                              loading: 
                      notification?.id === $setup.loadingNotificationId
                        ? $setup.isAcceptingTradeNetworkRequest
                        : false
                    ,
                              onClick: ($event: any) => (
                      $setup.changeRequestStatus(
                        $setup.UserNetworkRequestStatus.ACCEPTED,
                        notification?.sourceId,
                        notification?.id,
                        notification
                      )
                    )
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Accept")
                              ]),
                              _: 2
                            }, 1032, ["loading", "onClick"]),
                            _createVNode(_component_v_btn, {
                              class: "notification_wrapper__reject",
                              variant: "tonal",
                              loading: 
                      notification?.id === $setup.loadingNotificationId
                        ? $setup.isRejectingTradeNetworkRequest
                        : false
                    ,
                              onClick: ($event: any) => (
                      $setup.changeRequestStatus(
                        $setup.UserNetworkRequestStatus.REJECTED,
                        notification?.sourceId,
                        notification?.id,
                        notification
                      )
                    )
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Reject")
                              ]),
                              _: 2
                            }, 1032, ["loading", "onClick"])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (
                notification.type ===
                $setup.UserNotificationType.CLIENT_HISTORICAL_PROJECT
              )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                        _createElementVNode("div", _hoisted_68, [
                          _createElementVNode("div", _hoisted_69, [
                            _createElementVNode("p", null, [
                              _createElementVNode("strong", null, _toDisplayString(notification.content), 1)
                            ]),
                            _createElementVNode("span", null, _toDisplayString(notification?.timeAgo), 1)
                          ]),
                          _createElementVNode("div", _hoisted_70, [
                            _createVNode(_component_v_btn, {
                              class: "notification_wrapper__accept",
                              variant: "tonal",
                              onClick: ($event: any) => (
                      $setup.onClientHistoricalProjectStatus(
                        $setup.HistoricProjectStatusEnum.ACCEPTED,
                        notification
                      )
                    )
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Accept")
                              ]),
                              _: 2
                            }, 1032, ["onClick"]),
                            _createVNode(_component_v_btn, {
                              class: "notification_wrapper__reject",
                              variant: "tonal",
                              onClick: ($event: any) => (
                      $setup.onClientHistoricalProjectStatus(
                        $setup.HistoricProjectStatusEnum.REJECTED,
                        notification
                      )
                    )
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Reject")
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (
                notification.type === $setup.UserNotificationType.ASSIGN_TEAM_ESTIMATE
              )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                        _createElementVNode("div", _hoisted_72, [
                          _createElementVNode("div", _hoisted_73, [
                            _createElementVNode("p", null, [
                              _createElementVNode("strong", null, _toDisplayString(notification.content), 1)
                            ]),
                            _createElementVNode("span", null, _toDisplayString(notification?.timeAgo), 1)
                          ]),
                          _createElementVNode("div", _hoisted_74, [
                            _createVNode(_component_v_btn, {
                              class: "notification_wrapper__accept",
                              variant: "tonal",
                              onClick: ($event: any) => (
                      $setup.onChangeAssignTeamEstimateStatus(
                        $setup.EstimatePhaseAssignMemberStatusEnum.ACCEPTED,
                        notification
                      )
                    )
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Accept")
                              ]),
                              _: 2
                            }, 1032, ["onClick"]),
                            _createVNode(_component_v_btn, {
                              class: "notification_wrapper__reject",
                              variant: "tonal",
                              onClick: ($event: any) => (
                      $setup.onChangeAssignTeamEstimateStatus(
                        $setup.EstimatePhaseAssignMemberStatusEnum.REJECTED,
                        notification
                      )
                    )
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Reject")
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (notification.type === $setup.UserNotificationType.USER_REQUEST)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
                        _createElementVNode("div", _hoisted_76, [
                          _createElementVNode("p", {
                            innerHTML: notification.content
                          }, null, 8, _hoisted_77),
                          _createElementVNode("span", null, _toDisplayString(notification?.timeAgo), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (notification.type === $setup.UserNotificationType.RECOMMENDATION)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
                        _createElementVNode("div", _hoisted_79, [
                          _createElementVNode("p", {
                            innerHTML: notification.content
                          }, null, 8, _hoisted_80),
                          _createElementVNode("span", null, _toDisplayString(notification?.timeAgo), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (
                notification.type === $setup.UserNotificationType.SITE_VISIT_REQUEST
              )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
                        _createElementVNode("div", _hoisted_82, [
                          _createElementVNode("p", {
                            innerHTML: notification.content
                          }, null, 8, _hoisted_83),
                          _createElementVNode("span", null, _toDisplayString(notification?.timeAgo), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (
                notification.type ===
                $setup.UserNotificationType.ACCEPTWORKSTATIONMEMBERREQUEST
              )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_84, [
                        _createElementVNode("div", _hoisted_85, [
                          _createElementVNode("div", _hoisted_86, [
                            _createElementVNode("p", {
                              innerHTML: notification.content
                            }, null, 8, _hoisted_87),
                            _createElementVNode("span", null, _toDisplayString(notification?.timeAgo), 1)
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (
                notification.type ===
                $setup.UserNotificationType.ACCEPTTRADENETWORKREQUEST
              )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_88, [
                        _createElementVNode("div", _hoisted_89, [
                          _createElementVNode("div", _hoisted_90, [
                            _createElementVNode("p", {
                              innerHTML: notification.content
                            }, null, 8, _hoisted_91),
                            _createElementVNode("span", null, _toDisplayString(notification?.timeAgo), 1)
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (
                notification.type ===
                $setup.UserNotificationType.FIRSTTIMEWORKSTATIONLAUNCH
              )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_92, [
                        _createElementVNode("div", _hoisted_93, [
                          _createElementVNode("div", _hoisted_94, [
                            _createElementVNode("p", null, _toDisplayString(notification.content), 1),
                            _createElementVNode("span", null, _toDisplayString(notification?.timeAgo), 1)
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (
                notification.type === $setup.UserNotificationType.TRADE_USER_CONNECTION
              )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_95, [
                        _createElementVNode("div", _hoisted_96, [
                          _createElementVNode("div", _hoisted_97, [
                            _createElementVNode("p", null, [
                              _createElementVNode("strong", null, _toDisplayString(notification.content), 1),
                              _createTextVNode(" wants to add you to their preferred trade contractors list for future projects. ")
                            ]),
                            _createElementVNode("span", null, _toDisplayString(notification?.timeAgo), 1)
                          ]),
                          _createElementVNode("div", _hoisted_98, [
                            _createVNode(_component_v_btn, {
                              class: "notification_wrapper__accept",
                              variant: "tonal",
                              onClick: ($event: any) => (
                      $setup.acceptInvitationStatus(
                        notification?.id,
                        notification?.token
                      )
                    )
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Accept")
                              ]),
                              _: 2
                            }, 1032, ["onClick"]),
                            _createVNode(_component_v_btn, {
                              class: "notification_wrapper__reject",
                              variant: "tonal",
                              loading: 
                      notification?.id === $setup.loadingNotificationId
                        ? $setup.invitationRejectLoader
                        : false
                    ,
                              onClick: ($event: any) => (
                      $setup.rejectInvitationStatus(notification?.id, notification?.id)
                    )
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Reject")
                              ]),
                              _: 2
                            }, 1032, ["loading", "onClick"])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (
                notification.type ===
                $setup.UserNotificationType.CONTRACTORINVITEREQUEST
              )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_99, [
                        _createElementVNode("div", _hoisted_100, [
                          _createElementVNode("div", _hoisted_101, [
                            _createElementVNode("p", {
                              innerHTML: notification.content
                            }, null, 8, _hoisted_102),
                            _createElementVNode("span", null, _toDisplayString(notification?.timeAgo), 1)
                          ]),
                          _createElementVNode("div", _hoisted_103, [
                            _createVNode(_component_v_btn, {
                              class: "notification_wrapper__accept",
                              variant: "tonal",
                              onClick: ($event: any) => (
                      $setup.acceptInvitationStatus(
                        notification?.sourceId,
                        notification?.metadata,
                        notification?.id
                      )
                    )
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Accept")
                              ]),
                              _: 2
                            }, 1032, ["onClick"]),
                            _createVNode(_component_v_btn, {
                              class: "notification_wrapper__reject",
                              variant: "tonal",
                              loading: 
                      notification?.id === $setup.loadingNotificationId
                        ? $setup.invitationRejectLoader
                        : false
                    ,
                              onClick: ($event: any) => (
                      $setup.rejectInvitationStatus(
                        notification?.sourceId,
                        notification?.id
                      )
                    )
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Reject ")
                              ]),
                              _: 2
                            }, 1032, ["loading", "onClick"])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (
                notification.type ===
                  $setup.UserNotificationType.OUTERNETWORKREQUEST &&
                $setup.activeUserWorkstation?.verificationStatus ===
                  $setup.UserVerificationStatusEnum.VERIFIED
              )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_104, [
                        _createElementVNode("div", _hoisted_105, [
                          _createElementVNode("div", _hoisted_106, [
                            ($setup.outerNetworkRequestStatus(notification?.metadata))
                              ? (_openBlock(), _createElementBlock("p", _hoisted_107, [
                                  _createElementVNode("strong", null, _toDisplayString(notification.content), 1),
                                  _createTextVNode(" wants to add you to their preferred trade contractors list for future projects. ")
                                ]))
                              : _createCommentVNode("", true),
                            (!$setup.outerNetworkRequestStatus(notification?.metadata))
                              ? (_openBlock(), _createElementBlock("p", _hoisted_108, [
                                  _createTextVNode(" You have " + _toDisplayString($setup.showOuterNetworkStatus(notification?.metadata)) + " of ", 1),
                                  _createElementVNode("strong", null, _toDisplayString(notification.content) + "'s", 1),
                                  _createTextVNode(" preferred trade contractors request ")
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("span", null, _toDisplayString(notification?.timeAgo), 1)
                          ]),
                          ($setup.outerNetworkRequestStatus(notification?.metadata))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_109, [
                                _createVNode(_component_v_btn, {
                                  class: "notification_wrapper__accept",
                                  variant: "tonal",
                                  loading: 
                      notification?.id === $setup.loadingNotificationId
                        ? $setup.externalTradeNetworkRequestAcceptLoader
                        : false
                    ,
                                  onClick: ($event: any) => (
                      $setup.acceptExternalTradeNetworkInvitationStatus(
                        notification?.id,
                        notification?.metadata
                      )
                    )
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Accept")
                                  ]),
                                  _: 2
                                }, 1032, ["loading", "onClick"]),
                                _createVNode(_component_v_btn, {
                                  class: "notification_wrapper__reject",
                                  variant: "tonal",
                                  loading: 
                      notification?.id === $setup.loadingNotificationId
                        ? $setup.externalTradeNetworkRequestAcceptLoader
                        : false
                    ,
                                  onClick: ($event: any) => (
                      $setup.rejectExternalTradeNetworkInvitationStatus(
                        notification?.id,
                        notification?.metadata
                      )
                    )
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Reject")
                                  ]),
                                  _: 2
                                }, 1032, ["loading", "onClick"])
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (notification.type === $setup.UserNotificationType.PROJECT_CHAT)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_110, [
                        _createElementVNode("div", _hoisted_111, [
                          _createElementVNode("div", _hoisted_112, [
                            _createElementVNode("p", null, _toDisplayString(notification.content), 1),
                            _createElementVNode("span", null, _toDisplayString(notification?.timeAgo), 1)
                          ]),
                          _createElementVNode("div", _hoisted_113, [
                            _createVNode(_component_v_btn, {
                              class: "notification_wrapper__accept",
                              variant: "tonal",
                              loading: 
                      notification?.id === $setup.loadingNotificationId
                        ? $setup.chatRequestAcceptLoader
                        : false
                    ,
                              onClick: ($event: any) => (
                      $setup.acceptProjectInvitationStatus(
                        notification?.id,
                        notification?.sourceId
                      )
                    )
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Accept")
                              ]),
                              _: 2
                            }, 1032, ["loading", "onClick"]),
                            _createVNode(_component_v_btn, {
                              class: "notification_wrapper__reject",
                              variant: "tonal",
                              loading: 
                      notification?.id === $setup.loadingNotificationId
                        ? $setup.chatRequestRejectLoader
                        : false
                    ,
                              onClick: ($event: any) => (
                      $setup.rejectProjectInvitationStatus(
                        notification?.id,
                        notification?.sourceId
                      )
                    )
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Reject")
                              ]),
                              _: 2
                            }, 1032, ["loading", "onClick"])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (
                notification.type ===
                $setup.UserNotificationType.PROPERTY_USER_CONNECTION
              )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_114, [
                        _createElementVNode("div", _hoisted_115, [
                          _createElementVNode("div", _hoisted_116, [
                            _createElementVNode("p", null, [
                              _createElementVNode("strong", null, _toDisplayString(notification.content), 1),
                              _createTextVNode(" wants to add you to their connection list for future projects. ")
                            ]),
                            _createElementVNode("span", null, _toDisplayString(notification?.timeAgo), 1)
                          ]),
                          _createElementVNode("div", _hoisted_117, [
                            _createVNode(_component_v_btn, {
                              class: "notification_wrapper__accept",
                              variant: "tonal",
                              onClick: ($event: any) => (
                      $setup.acceptPropertyInvitationStatus(
                        notification?.id,
                        notification?.token
                      )
                    )
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Accept")
                              ]),
                              _: 2
                            }, 1032, ["onClick"]),
                            _createVNode(_component_v_btn, {
                              class: "notification_wrapper__reject",
                              variant: "tonal",
                              onClick: ($event: any) => ($setup.rejectPropertyInvitationStatus(notification?.id))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Reject ")
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (notification.type === $setup.UserNotificationType.VERIFY_JOBS)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_118, [
                        _createElementVNode("div", _hoisted_119, [
                          _createElementVNode("div", _hoisted_120, [
                            _createElementVNode("p", null, [
                              _createElementVNode("strong", null, _toDisplayString(notification.content), 1)
                            ]),
                            _createElementVNode("span", null, _toDisplayString(notification?.timeAgo), 1)
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (notification.type === $setup.UserNotificationType.VIDEO_CALL)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_121, [
                        _createElementVNode("div", _hoisted_122, [
                          _createElementVNode("div", _hoisted_123, [
                            _createElementVNode("p", null, [
                              _createElementVNode("strong", null, _toDisplayString(notification.content), 1)
                            ]),
                            _createElementVNode("span", null, _toDisplayString(notification?.timeAgo), 1)
                          ]),
                          _createElementVNode("div", _hoisted_124, [
                            _createVNode(_component_v_btn, {
                              class: "notification_wrapper__accept",
                              variant: "tonal",
                              onClick: ($event: any) => ($setup.onClickAcceptVideoCall(notification))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Accept")
                              ]),
                              _: 2
                            }, 1032, ["onClick"]),
                            _createVNode(_component_v_btn, {
                              class: "notification_wrapper__reject",
                              variant: "tonal",
                              onClick: ($event: any) => ($setup.onClickRejectVideoCall(notification))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Reject")
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (
                notification.type === $setup.UserNotificationType.RAISE_PROJECT_TYPE
              )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_125, [
                        _createElementVNode("div", _hoisted_126, [
                          _createElementVNode("div", _hoisted_127, [
                            _createElementVNode("p", null, [
                              _createElementVNode("strong", null, _toDisplayString(notification.content), 1)
                            ]),
                            _createElementVNode("span", null, _toDisplayString(notification?.timeAgo), 1)
                          ]),
                          _createElementVNode("div", _hoisted_128, [
                            _createVNode(_component_v_btn, {
                              class: "notification_wrapper__accept",
                              variant: "tonal",
                              onClick: ($event: any) => (
                      $setup.updateRaiseProjectRequestStatus(
                        $setup.ProjectMetaDataStatusEnum.ACCEPTED,
                        Number(notification?.sourceId),
                        notification?.id,
                        notification?.metadata
                      )
                    )
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Accept")
                              ]),
                              _: 2
                            }, 1032, ["onClick"]),
                            _createVNode(_component_v_btn, {
                              class: "notification_wrapper__reject",
                              variant: "tonal",
                              onClick: ($event: any) => (
                      $setup.updateRaiseProjectRequestStatus(
                        $setup.ProjectMetaDataStatusEnum.REJECTED,
                        Number(notification?.sourceId),
                        notification?.id,
                        notification?.metadata
                      )
                    )
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Reject")
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (
                notification.type === $setup.UserNotificationType.CLIENT_RAISE_ESTIMATE
              )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_129, [
                        _createElementVNode("div", _hoisted_130, [
                          _createElementVNode("div", _hoisted_131, [
                            _createElementVNode("p", null, [
                              _createElementVNode("strong", null, _toDisplayString(notification.content), 1)
                            ]),
                            _createElementVNode("span", null, _toDisplayString(notification?.timeAgo), 1)
                          ]),
                          _createElementVNode("div", _hoisted_132, [
                            _createVNode(_component_v_btn, {
                              class: "notification_wrapper__accept",
                              variant: "tonal",
                              onClick: ($event: any) => ($setup.clientRaiseEstimateAction('accepted', notification))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Accept")
                              ]),
                              _: 2
                            }, 1032, ["onClick"]),
                            _createVNode(_component_v_btn, {
                              class: "notification_wrapper__reject",
                              variant: "tonal",
                              onClick: ($event: any) => ($setup.clientRaiseEstimateAction('rejected', notification))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Reject")
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (
                notification.type ===
                $setup.UserNotificationType.REJECTED_RAISE_PROJECT
              )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_133, [
                        _createElementVNode("div", _hoisted_134, [
                          _createElementVNode("div", _hoisted_135, [
                            _createElementVNode("p", null, [
                              _createElementVNode("strong", null, _toDisplayString(notification.content), 1)
                            ]),
                            _createElementVNode("span", null, _toDisplayString(notification?.timeAgo), 1)
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (
                notification.type === $setup.UserNotificationType.RAISE_NOTIFICATION
              )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_136, [
                        _createElementVNode("div", _hoisted_137, [
                          _createElementVNode("div", _hoisted_138, [
                            _createElementVNode("p", null, [
                              _createElementVNode("strong", null, _toDisplayString(notification.content), 1)
                            ]),
                            _createElementVNode("span", null, _toDisplayString(notification?.timeAgo), 1)
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (
                notification.type ===
                $setup.UserNotificationType.RAISE_ISSUE_BY_OCCUPIER
              )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_139, [
                        _createElementVNode("div", _hoisted_140, [
                          _createElementVNode("div", _hoisted_141, [
                            _createElementVNode("p", null, [
                              _createElementVNode("strong", null, _toDisplayString(notification.content), 1)
                            ]),
                            _createElementVNode("span", null, _toDisplayString(notification?.timeAgo), 1)
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (notification.type === $setup.UserNotificationType.ACCOUNT_VERIFIED)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_142, [
                        _createElementVNode("div", _hoisted_143, [
                          _createElementVNode("div", _hoisted_144, [
                            _createElementVNode("p", null, [
                              _createElementVNode("strong", null, _toDisplayString(notification.content), 1)
                            ]),
                            _createElementVNode("span", null, _toDisplayString(notification?.timeAgo), 1)
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (
                [
                  $setup.UserNotificationType.PROJECT_COMPLETED,
                  $setup.UserNotificationType.ACCEPT_PROJECT_ESTIMATE,
                  $setup.UserNotificationType.UPDATE_PROJECT_ESTIMATE_SUB_CONTRACTOR,
                  $setup.UserNotificationType.START_PROJECT_RIGHT_AWAY,
                  $setup.UserNotificationType.UPDATE_PROJECT_ESTIMATE,
                ].includes(notification.type)
              )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_145, [
                        _createElementVNode("div", _hoisted_146, [
                          _createElementVNode("div", _hoisted_147, [
                            _createElementVNode("p", null, [
                              _createElementVNode("strong", null, _toDisplayString(notification.content), 1)
                            ]),
                            _createElementVNode("span", null, _toDisplayString(notification?.timeAgo), 1)
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (
                ![
                  $setup.UserNotificationType.WA_MEMBER_REQUEST,
                  $setup.UserNotificationType.USER_NETWORK,
                  $setup.UserNotificationType.CLIENT_HISTORICAL_PROJECT,
                  $setup.UserNotificationType.ASSIGN_TEAM_ESTIMATE,
                  $setup.UserNotificationType.TRADE_USER_CONNECTION,
                  $setup.UserNotificationType.CONTRACTORINVITEREQUEST,
                  $setup.UserNotificationType.OUTERNETWORKREQUEST,
                  $setup.UserNotificationType.PROJECT_CHAT,
                  $setup.UserNotificationType.PROPERTY_USER_CONNECTION,
                  $setup.UserNotificationType.VIDEO_CALL,
                  $setup.UserNotificationType.RAISE_PROJECT_TYPE,
                ].includes(notification.type)
              )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_148, [
                        _createVNode(_component_v_menu, {
                          id: String(notification.id),
                          location: "bottom",
                          class: "dropdown-card"
                        }, {
                          activator: _withCtx(({ props }) => [
                            _createVNode(_component_v_icon, _mergeProps({ ref_for: true }, props), {
                              default: _withCtx(() => [
                                _hoisted_149
                              ]),
                              _: 2
                            }, 1040)
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_v_list, { class: "delete_wrapper" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item, {
                                  onClick: _withModifiers(($event: any) => ($setup.onHandleAction(notification?.id)), ["stop"])
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_TrashIcon),
                                    _createTextVNode(" Delete ")
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"])
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1032, ["id"])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ], 8, _hoisted_6))
            }), 128))
          ]))
        }), 128))
      ], 2)
    ], 2),
    ($setup.isShowSelectMultipleWorkstationModal)
      ? (_openBlock(), _createBlock(_component_SelectMultipleWorkstationModal, {
          key: 0,
          onCloseMultiSelectWorkstationModal: $setup.closeMultiSelectWorkstationModal,
          acceptInvitationDetails: $setup.acceptInvitationDetails
        }, null, 8, ["onCloseMultiSelectWorkstationModal", "acceptInvitationDetails"]))
      : _createCommentVNode("", true),
    _withDirectives(_createVNode(_component_VideoComponent, {
      roomDetails: $setup.roomDetails,
      isDirectJoinVideoCall: true,
      ref: "videoComponent",
      onLeaveCall: $setup.leaveCall
    }, null, 8, ["roomDetails", "onLeaveCall"]), [
      [_vShow, $setup.videoConsultationStatus]
    ])
  ], 64))
}